<template>
  <div>
    <v-layout wrap justify-center pt-8>
      <v-flex>
        <div
          id="map77"
          style="
            width: auto;
            height: 550px;
            position: relative;
            overflow: hidden;
          "
        ></div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyB-wSOSvoBXfA5vn-23GR7OU5qTm8BFwlk&libraries=places,visualization,drawing"></script>
<script>
import store from "./../../store";
import axios from "axios";
var marker,
  features,
  gmarkers = [];
let map, popup, Popup;
var myLatLng;
export default {
  props: ["storage", "placeList"],
  data() {
    return {
      map: "",
      mapData: [],
      markersArray: [],
      latitudes: null,
      longtitudes: null,
    };
  },
  computed: {
    appEach() {
      return store.state.eachLoc;
    },
    appStartOrStop() {
      this.deleteMarkers();
      for (let i = 0; i < this.storage.length; i++) {
        this.longtitudes = this.storage[i].gps[0];
        this.latitudes = this.storage[i].gps[1];

        let longlatitude = { lat: this.latitudes, lng: this.longtitudes };

        this.addMarker(longlatitude, this.storage[i]);
      }
      return store.state.startOrStop;
    },
  },
  watch: {
    appStartOrStop() {
      // console.log("No New Bus");
      // if (this.appStartOrStop == "started") {
      //   console.log("New Bus");
      //   this.getData();
      // } else if (this.appStartOrStop == "notstarted") {
      //   console.log("else if");
      //   this.getData();
      // }
    },
    appEach() {
      this.deleteMarkers();
      for (let i = 0; i < this.storage.length; i++) {
        this.longtitudes = this.storage[i].gps[0];
        this.latitudes = this.storage[i].gps[1];

        if (this.storage[i]._id == this.appEach.tripId) {
          this.storage[i].gps = [];
          this.storage[i].gps.push(this.appEach.lon);
          this.storage[i].gps.push(this.appEach.lat);
          this.longtitudes = this.appEach.lon;
          this.latitudes = this.appEach.lat;
        }

        let longlatitude = { lat: this.latitudes, lng: this.longtitudes };

        this.addMarker(longlatitude, this.storage[i]);
      }

      // marker.setMap(null);
      // console.log("Appeach=", this.appEach);
      // for (let i = 0; i < this.storage.length; i++) {
      //   if (this.storage[i]._id == this.appEach.tripId) {
      //     this.storage[i].gps = [];
      //     this.storage[i].gps.push(this.appEach.lon);
      //     this.storage[i].gps.push(this.appEach.lat);
      //   }
      // }
      // this.reApply();
      // console.log("Stotrage=", this.storage);
    },
  },
  mounted() {
    // this.Ginitialize();
    this.initMap();
  },
  methods: {
    deleteMarkers() {
      this.clearMarkers();
      this.markersArray = [];
    },

    clearMarkers() {
      this.setMapOnAll(null);
    },
    setMapOnAll(map) {
      for (var i = 0; i < this.markersArray.length; i++) {
        this.markersArray[i].setMap(map);
      }
    },
    addMarker(location, data) {
      let marker = new google.maps.Marker({
        position: location,
        map: map,
        title: data.busid.name,
        icon: {
          url: require("./../../assets/images/bus3.png"),
          size: new google.maps.Size(36, 50),
          scaledSize: new google.maps.Size(36, 50),
          anchor: new google.maps.Point(0, 50),
        },
      });

      var infoWindow = new google.maps.InfoWindow();

      google.maps.event.addListener(marker, "click", function (e) {
        infoWindow.setContent(
          this.storage
          // storage.description + ">" + marker.getPosition().toUrlValue(6)
        );
        infoWindow.open(map, marker);
      });
      (function (marker, data) {
        google.maps.event.addListener(marker, "click", function (e) {
          infoWindow.setContent(
            "<br> <b>" +
              data.busid.name +
              " - " +
              data.name +
              "</b> <br><br>" +
              "Total No. of Students &nbsp;" +
              data.busAttendance.totalNumberofStudents +
              "<br>" +
              "Total Boarded &nbsp;" +
              data.busAttendance.numberOfStudentsBoarded +
              "<br>" +
              "Total Deborded &nbsp;" +
              data.busAttendance.numberOfStudentsDeBoarded
            // data.description + "r>" + marker.getPosition().toUrlValue(6)
          );
          infoWindow.open(map, marker);
        });
      })(marker, data);
      this.markersArray.push(marker);
    },

    // getData() {
    //   this.appLoading = true;
    //   axios({
    //     method: "post",
    //     url: "/bus/trip/list",
    //     headers: {
    //       token: localStorage.getItem("token"),
    //     },
    //     data: {
    //       tripStatus: "Started",
    //     },
    //   })
    //     .then((response) => {
    //       this.appLoading = false;
    //       if (response.data.status) {
    //         this.locationList = response.data.data;
    //         // this.Ginitialize()
    //         this.reApply();
    //       } else {
    //         this.snackbar = true;
    //         this.msg = response.data.msg;
    //       }
    //     })
    //     .catch((err) => {
    //       this.appLoading = false;
    //       console.log(err);
    //     });
    // },

    initMap() {
      myLatLng = { lat: 10.8505, lng: 76.2711 };

      // myLatLng=this.storage
      map = new google.maps.Map(document.getElementById("map77"), {
        center: { lat: 9.528484, lng: 76.824133 },
        zoom: 20,
      });
      marker = new google.maps.Marker({
        position: { lat: this.storage[0].gps[1], lng: this.storage[0].gps[0] },
        map: map,
        icon: {
          url: require("./../../assets/images/bus2.png"),
          size: new google.maps.Size(36, 50),
          scaledSize: new google.maps.Size(36, 50),
          anchor: new google.maps.Point(0, 50),
        },
      });
      map = new google.maps.Map(document.getElementById("map77"), {
        center: { lat: this.storage[0].gps[1], lng: this.storage[0].gps[0] },
        zoom: 20,
      });
      marker.setMap(null);
      this.reApply();
      // var dt=[]
      // for (let i = 0; i < this.storage.length; i++) {
      //   var latitude = this.storage[i].gps[1];
      //   var long = this.storage[i].gps[0];
      //   var obj = {
      //     position: new google.maps.LatLng(latitude, long),
      //     title: this.storage[i].busid.name,
      //     id: this.storage[i]._id,
      //   };

      //   dt.push(JSON.parse(JSON.stringify(obj)));
      //   if (dt.length > 0)
      //     map = new google.maps.Map(document.getElementById("map77"), {
      //       center: dt[0].position,
      //       zoom: 20,
      //     });
      // }
      // this.Ginitialize();
      // this.plotMarker();
      // this.reApply();
    },
    // plotMarker() {
    //   // const iconBase = "https://developers.google.com/maps/documentation/javascript/examples/full/images/";
    //   const iconBase = require("./../../assets/images/bus2.png");
    //   const icons = {
    //     stops: {
    //       icon: iconBase,
    //     },
    //   };
    //   var features = [];
    //   var placeFeatures = [];
    //   var locs = [];
    //   if (this.storage) console.log("cco=", this.storage);

    //   //For marking all trips
    //   for (let i = 0; i < this.storage.length; i++) {
    //     var latitude = this.storage[i].gps[1];
    //     var long = this.storage[i].gps[0];
    //     var obj = {
    //       position: new google.maps.LatLng(latitude, long),
    //       title: this.storage[i].busid.name,
    //       id: this.storage[i]._id,
    //     };

    //     features.push(JSON.parse(JSON.stringify(obj)));
    //     if (features.length > 0)
    //       map = new google.maps.Map(document.getElementById("map77"), {
    //         center: features[0].position,
    //         zoom: 20,
    //       });
    //   }
    //   console.log("AppLocate=", this.appLocation);

    //   for (let i = 0; i < features.length; i++) {
    //     console.log("Fate", features[i]);

    //     if (i >= 1) break;

    //     marker = new google.maps.Marker({
    //       position: features[i].position,
    //       map: map,
    //       title: features[i].title,
    //       icon: {
    //         url: iconBase,
    //         size: new google.maps.Size(36, 50),
    //         scaledSize: new google.maps.Size(36, 50),
    //         anchor: new google.maps.Point(0, 50),
    //       },
    //     });
    //   }

    //   // for (let ik = 0, length = this.storage.length; ik < length; ik++) {
    //   //   var latLng = new google.maps.LatLng(
    //   //     this.storage[ik].gps[1],
    //   //     this.storage[ik].gps[0]
    //   //   );
    //   //   // bounds.extend(latLng);
    //   //   var markeri = new google.maps.Marker({
    //   //     position: latLng,
    //   //     map: map,
    //   //     title: this.storage[ik].busid.name,
    //   //     icon: {
    //   //       url: require("./../../assets/images/bus2.png"),
    //   //       size: new google.maps.Size(36, 50),
    //   //       scaledSize: new google.maps.Size(36, 50),
    //   //       anchor: new google.maps.Point(0, 50),
    //   //     },
    //   //   });
    //   //   gmarkers.push(markeri);
    //   // }
    // },
    // reApply() {
    //   console.log("Cllled re");
    //   var refeatures = [];
    //   for (let ii = 0; ii < this.storage.length; ii++) {
    //     let latitude = this.storage[ii].gps[1];
    //     let long = this.storage[ii].gps[0];
    //     var reobj = {
    //       position: new google.maps.LatLng(latitude, long),
    //       title: this.storage[ii].busid.name,
    //       id: this.storage[ii]._id,
    //     };

    //     refeatures.push(JSON.parse(JSON.stringify(reobj)));
    //   }
    //   var bounds = new google.maps.LatLngBounds();

    //   // delete all existing markers first
    //   for (var i = 0; i < gmarkers.length; i++) {
    //     gmarkers[i].setMap(null);
    //   }
    //   gmarkers = [];

    //   // add new markers from the JSON data
    //   for (var i = 0, length = this.storage.length; i < length; i++) {
    //     var latLng = new google.maps.LatLng(
    //       this.storage[i].gps[1],
    //       this.storage[i].gps[0]
    //     );
    //     // bounds.extend(latLng);
    //     var marker = new google.maps.Marker({
    //       position: latLng,
    //       map: map,
    //       title: this.storage[i].busid.name,
    //       icon: {
    //         url: require("./../../assets/images/bus3.png"),
    //         size: new google.maps.Size(36, 50),
    //         scaledSize: new google.maps.Size(36, 50),
    //         anchor: new google.maps.Point(0, 50),
    //       },
    //     });
    //     var infoWindow = new google.maps.InfoWindow();

    //     google.maps.event.addListener(marker, "click", function (e) {
    //       infoWindow.setContent(
    //         this.storage
    //         // storage.description + ">" + marker.getPosition().toUrlValue(6)
    //       );
    //       infoWindow.open(map, marker);
    //     });
    //     (function (marker, data) {
    //       google.maps.event.addListener(marker, "click", function (e) {
    //         infoWindow.setContent(
    //           "<br> <b>" +
    //             data.busid.name + ' - ' + data.name +
    //             "</b> <br><br>" +
    //             "Total No. of Students &nbsp;" +
    //             data.busAttendance.totalNumberofStudents +
    //             "<br>" +
    //             "Total Boarded &nbsp;" +
    //             data.busAttendance.numberOfStudentsBoarded +
    //             "<br>" +
    //             "Total Deborded &nbsp;" +
    //             data.busAttendance.numberOfStudentsDeBoarded
    //           // data.description + "r>" + marker.getPosition().toUrlValue(6)
    //         );
    //         infoWindow.open(map, marker);
    //       });
    //     })(marker, this.storage[i]);

    //     gmarkers.push(marker);
    //   }

    //   // zoom the map to show all the markers, may not be desirable.
    //   // map.fitBounds(bounds);
    //   this.Ginitialize;

    // },

    // Ginitialize() {
    //   // initialize the map on page load.
    //   var mapOptions = {
    //     // center: new google.maps.LatLng(35.66, -80.5),
    //     // zoom: 8,
    //     mapTypeId: google.maps.MapTypeId.ROADMAP,
    //   };
    //   map = new google.maps.Map(document.getElementById("map77"), mapOptions);

    //   // add the markers to the map if they have been loaded already.
    //   if (gmarkers.length > 0) {
    //     for (var i = 0; i < gmarkers.length; i++) {
    //       gmarkers[i].setMap(map);
    //     }
    //   }
    // },
  },
};
</script>
<style>
#map77 {
  height: 100%;
}
</style>
